import * as Yup from 'yup';

const requiredText = () => Yup.string().trim().required('Required');

const descriptionOfRiskRowSchema = () =>
  Yup.object({
    riskDescription: requiredText(),
    geoLocationID: requiredText()
  });

export const descriptionOfRiskValidationSchema = () =>
  Yup.object({
    riskDescriptionDetails: Yup.array()
      .of(descriptionOfRiskRowSchema())
      .min(1, 'At least one row is required')
  });
